import React, { Component } from 'react';
import {connect} from 'react-redux';
import {
    Switch,
    Route,
} from 'react-router-dom';
import { Spin, Icon } from 'antd';
import Layout from '../Layout';
import Sidebar from './Sidebar';
import Profile from './Profile';
import Admins from './Admins';
import AdminContainer from './AdminContainer';
import Insurances from './Insurances';
import Qualifications from './BusinessQualification';
import GasSafe from './GasSafe';
import EngineersContainer from './EngineersContainer';
import NonEngineersContainer from './NonEngineersContainer';

class Provider extends Component {
    renderRoutes() {
        const {match, me: {roles}} = this.props;
        const role = roles.map(r => r.name).pop();
        if (!role) return null;

        return (
            <div>
                <Switch>
                    <Route path={`${match.url}/profile`} component={Profile}/>
                    {role !== 'contractor_admin' ? (
                        <Route path={`${match.url}/admins`} exact component={Admins}/>
                    ) : null}

                    {role !== 'contractor_admin' ? (
                        <Route path={`${match.url}/admins/new`} exact component={AdminContainer}/>
                    ) : null}

                    {role !== 'contractor_admin' ? (
                        <Route path={`${match.url}/admins/:admin/edit`} component={AdminContainer}/>
                    ) : null}
                    <Route path={`${match.url}/insurances`} component={Insurances}/>
                    <Route path={`${match.url}/gas-safe`} component={GasSafe}/>
                    <Route path={`${match.url}/qualifications`} component={Qualifications}/>
                    <Route path={`${match.url}/engineers`} component={EngineersContainer}/>
                    <Route path={`${match.url}/non-engineers`} component={NonEngineersContainer}/>
                </Switch>
            </div>
        );
    }
    renderLoading() {
        const icon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
        return <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            bottom: 0,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0
        }}>
            <Spin size="large" tip="LOADING" indicator={icon}/>
        </div>;
    }
    render() {
        const {me: {isFetching}} = this.props;
        const renderSidebar = props => <Sidebar {...props}/>;

        return (
            <Layout renderSidebar={renderSidebar}>
                {isFetching ? this.renderLoading() : this.renderRoutes()}
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {
        me: state.me,
        auth: state.auth
    };
}

export default connect(mapStateToProps)(Provider);


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/Root.js